export enum TesMovimientoEstado {
  BORRADOR = 'BORRADOR',
  CONFIRMADO = 'CONFIRMADO',
  ANULADO = 'ANULADO',
}

export enum TesMovimientoTipo {
  INGRESO = 'INGRESO',
  EGRESO = 'EGRESO',
}

export enum TesOrigenTipo {
  TRANSFERENCIA_ORIGEN = 'TRANSFERENCIA_ORIGEN',
  TRANSFERENCIA_DESTINO = 'TRANSFERENCIA_DESTINO',
  CHEQUE_DEPOSITADO = 'CHEQUE_DEPOSITADO',
  CHEQUE_DEBITADO = 'CHEQUE_DEBITADO',
}

export enum TesChequeEstado {
  EN_CARTERA = 'EN_CARTERA',
  DEPOSITADO = 'DEPOSITADO',
  DEBITADO = 'DEBITADO',
  RECHAZADO = 'RECHAZADO',
  DEVUELTO = 'DEVUELTO',
  ANULADO = 'ANULADO',
}

export enum TesTransferenciaEstado {
  CONFIRMADO = 'CONFIRMADO',
  ANULADO = 'ANULADO',
}

export enum TesOrdenPagoEstado {
  BORRADOR = 'BORRADOR',
  PAGADO = 'PAGADO',
  ANULADA = 'ANULADA',
}

export enum CuentaCobrarEstado {
  PENDIENTE = 'pendiente',
  PARCIAL = 'parcial',
  PAGADA = 'pagada',
}

export enum TesExtractoEstado {
  PENDIENTE = 'PENDIENTE',
  PARCIAL = 'PARCIAL',
  CONCILIADO = 'CONCILIADO',
}
